import { render, staticRenderFns } from "./ProformaInvoicesView.vue?vue&type=template&id=b31bd814&lang=pug"
import script from "./ProformaInvoicesView.vue?vue&type=script&lang=ts"
export * from "./ProformaInvoicesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b31bd814')) {
      api.createRecord('b31bd814', component.options)
    } else {
      api.reload('b31bd814', component.options)
    }
    module.hot.accept("./ProformaInvoicesView.vue?vue&type=template&id=b31bd814&lang=pug", function () {
      api.rerender('b31bd814', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billing/ProformaInvoices/ProformaInvoicesView.vue"
export default component.exports